{
  "cameraListPanel": {
    "text": "カメラ",
    "text2": "エリアを選択してください",
    "text3": "すべて削除",
    "label": "配置済み {{length}}台",
    "label2": "未配置 — ドラッグして配置",
    "text4": "このエリアにカメラがありません"
  },
  "cameraRow": {
    "ariaLabel": "{{name}} の配置を削除"
  },
  "mapDeleteDialog": {
    "enqueueSnackbar": "マップを削除しました",
    "enqueueSnackbar2": "マップの削除に失敗しました",
    "text": "削除中...",
    "title": "マップを削除",
    "text2": "」を削除しますか？",
    "text3": "配置したカメラもまとめて外れます。この操作は元に戻せません。"
  },
  "mapDropZone": {
    "ariaLabel": "マップ画像をアップロード",
    "text": "変換しています...",
    "text2": "PDFまたは画像をアップロード",
    "text3": "ドラッグ＆ドロップ、またはクリックして選択"
  },
  "mapEditView": {
    "text": "マップ管理/マップ編集",
    "text2": "マップ管理/マップ作成"
  },
  "mapEditViewLayout": {
    "label": "マップ名",
    "label2": "エリア",
    "placeholder": "エリアを選択",
    "label3": "説明",
    "text": "保存中...",
    "text2": "保存する",
    "alt": "{{name}} の図面",
    "text3": "変換しています...",
    "text4": "マップ画像を差し替え",
    "text5": "ページの PDF です。1ページ目だけを使います",
    "text6": "配置したカメラは前の位置のまま残っています。必要なら置き直してください",
    "text7": "読み込み中...",
    "text8": "マップが見つかりませんでした",
    "text9": "削除されたか、閲覧する権限がありません",
    "text10": "このPDFにはフォントが含まれていないため、別の書体で表示しています。文字が元と違って見える場合は、画像で保存したものをアップロードしてください",
    "button": "マップ管理へ戻る"
  },
  "mapFilterBar": {
    "placeholder": "マップ名かエリア名で検索",
    "button": "マップ作成"
  },
  "mapImage": {
    "text": "図面を読み込めませんでした"
  },
  "mapManagementView": {
    "title": "マップ管理"
  },
  "mapManagementViewLayout": {
    "text": "件",
    "text2": "読み込み中...",
    "primary": "マップを取得できませんでした",
    "secondary": "時間をおいて開き直してください",
    "primary2": "マップがありません",
    "secondary2": "「マップ作成」から図面を登録します"
  },
  "mapSummaryCard": {
    "text": "サムネイルがありません",
    "text2": "台",
    "ariaLabel": "{{name}} の操作"
  },
  "mapTable": {
    "label": "マップ名",
    "label2": "エリア",
    "label3": "デバイス",
    "text": "台",
    "label4": "説明"
  },
  "mapViewModeToggle": {
    "ariaLabel": "グリッド表示",
    "ariaLabel2": "リスト表示"
  },
  "useMapEditState": {
    "text": "画像を読み込めませんでした",
    "enqueueSnackbar": "マップを保存しました",
    "text2": "マップを保存できませんでした"
  },
  "canvasEncode": {
    "error": "画像を書き出せませんでした",
    "error2": "画像を描画できませんでした"
  },
  "imagePipeline": {
    "error": "画像を読み込めませんでした",
    "error2": "PDF・PNG・JPEG のいずれかを選んでください",
    "error3": "画像の大きさを読み取れませんでした"
  },
  "inputLimits": {
    "fileTooLarge": "ファイルが大きすぎます。別のファイルを選んでください",
    "tooManyPixels": "画像の画素数が多すぎます。縮小してから選んでください"
  },
  "pdfRender": {
    "error": "画像を描画できませんでした"
  },
  "directionDial": {
    "text": "カメラ向き設定",
    "ariaLabel": "カメラ向き設定を閉じる",
    "ariaLabel2": "{{direction}}度"
  },
  "mapCanvas": {
    "ariaLabel": "拡大",
    "ariaLabel2": "縮小"
  },
  "mapPopup": {
    "label": "左上",
    "label2": "右上",
    "label3": "左下",
    "label4": "右下",
    "label5": "上辺",
    "label6": "下辺",
    "label7": "左辺",
    "label8": "右辺",
    "ariaLabel": "マップを閉じる",
    "alt": "{{title}} の図面",
    "ariaLabel2": "マップの大きさを変える（{{label}}）"
  }
}
